import queryString from "query-string";

import { SELL_VIA_EX_AGENT_REBATE } from "constants/actionTypes";

import { serializeSellViaExAgentRebate } from "lib/serializers/sellViaExAgentRebates";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";
import { URLCreatorProps } from "./types";

function urlCreator(props: URLCreatorProps = {}): string {
  const { action, changesSince, id } = props;
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction(
      "/v2/sell-via-ex-agent-rebates/",
      id,
      action,
    ),
    query: {
      changesSince,
    },
  });
}

export const SellViaExAgentRebateAction = offlineActionCreator(
  SELL_VIA_EX_AGENT_REBATE,
  serializeSellViaExAgentRebate,
  urlCreator,
  false,
);
